import React from 'react';
import {
  thumbnailStyle,
  thumbnailContainerStyle,
  imageContainerStyle,
} from './DashboardComponentStyles';

import UserBadge from './UserBadge';

interface ThumbnailBadgeProps {
  givenName?: string;
  tooltip?: boolean;
  link?: string;
  thumbNail?: boolean;
  maxThumbnailNumber?: number;
  usernames: string[];
}

export const UserBadgeThumbnails: React.FC<ThumbnailBadgeProps> = ({
  usernames,
  givenName,
  tooltip,
  thumbNail,
  link,
  maxThumbnailNumber,
}: ThumbnailBadgeProps): React.ReactElement => {
  const inputMaxThumbnailNumber = maxThumbnailNumber ?? usernames.length;

  const component = (
    <div style={thumbnailContainerStyle}>
      {usernames.map((username, index) => (
        <div
          key={username}
          style={thumbnailStyle(index, inputMaxThumbnailNumber)}
        >
          <div style={imageContainerStyle}>
            <UserBadge
              username={username}
              tooltip
              thumbNail
              link={link}
              givenName={givenName}
            />
          </div>
        </div>
      ))}
    </div>
  );

  return component;
};

export default UserBadgeThumbnails;
